<template>
  <div class="contactusPc">
    <img src="https://cdn.youjiajk.com/joinBannerPc_YS_new.png" width="100%" style="object-fit:cover;" />

    <div class="people backgroundGray">
      <div class="content">
        <div class="title">优加人才观</div>
        <div class="peopleCon">
          <div class="item">
            <img class="img1" src="../../assets/image/joinUsIcon1.png" alt="">
            <span class="txt">德才兼备</span>
          </div>
          <div class="item">
            <img class="img2" src="../../assets/image/joinUsIcon2.png" alt="">
            <span class="txt">专业自信</span>
          </div>
          <div class="item">
            <img class="img3" src="../../assets/image/joinUsIcon3.png" alt="">
            <span class="txt">拼搏自省</span>
          </div>
          <div class="item">
            <img class="img4" src="../../assets/image/joinUsIcon4.png" alt="">
            <span class="txt">皮实坚韧</span></span>
          </div>
        </div>
      </div>
    </div>

    <!-- 团队的构成 -->
    <div class="team">
      <div class="content">
        <div class="title">团队构成</div>
        <div class="teamCon">
          <img src="../../assets/image/joinUs2.png" alt="">
          <div class="conTxt">
            <h3>追梦路上，与优秀的人为伍！</h3>
            <p>
              优加健康在大健康行业的建设，吸引了来自平安、众安、泰康、京东健康、阿里健康、乐荐、圆心、小药药等业内知名企业的优秀人才聚集，搭建起一支行业经验丰富、拥有深刻行业洞察、执行力强、创新能力极强的优秀队伍。
            </p>
            <p>各方优秀人才聚集，投身大健康事业，共同搭建起一支行业经验丰富、拥有深刻行业洞察、执行力强、能打胜仗的、充满活力的、创新能力极强的优秀队伍！</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 加入 -->
    <div class="join backgroundGray">
      <div class="content">
        <div class="title">加入，优加家庭</div>
        <img class="joinUs" src="https://cdn.youjiajk.com/joinUs1.png" alt="">
      </div>
    </div>

    <!-- 招聘 -->
    <div class="recruitment container" id="text2">
      <div class="recruitmentTitle">
        <h2>我们，在寻找优秀的你</h2>
      </div>
      <div class="recruitmentCon">
        <div class="recruitmentItem" v-for="(item,index) in inviteList" :key="index">
          <div class="recruitmentItem_title" @click="item.isShow = !item.isShow">
            <div>
              <h2 class="recruitmentItem_title_h2">{{item.title}}</h2>
              <div class="title_desc">
                <span v-if="item.major">专业：{{item.major}}</span>
                <span>工作地点：{{item.address}}</span>
              </div>
            </div>
            <img :class="item.isShow ? 'addShow' : ''" src="../../assets/image/bottom.png" width="23" height="13"
              alt="">
          </div>
          <transition name="draw">
            <div class="responsibility" v-show="item.isShow">
              <div class="">
                <h3>岗位职责：</h3>
                <div class="htmlStyle" v-html="item.desc"></div>
                <h3>任职资格：</h3>
                <div class="htmlStyle" v-html="item.desc1"></div>
              </div>
              
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        boxshow: false
      }
    },
    props: {
      inviteList: {
        type: Array,
        default: []
      }
    },
    methods: {
      addActive($event) {
        $event.currentTarget.className = 'navItem actived'
      },
      removeActive($event) {
        $event.currentTarget.className = 'navItem'
      },
      goToAnchor(index) {
        this.$el.querySelector(`#text${index}`).scrollIntoView({
          behavior: "smooth", // 平滑过渡
          block: "start" // 上边框与视窗顶部平齐
        });
      },
      unfoldFn() {

      }
    }
  }
</script>

<style lang="less" scoped>
  .backgroundGray {
    background: #F8F9FD;
  }

  .content {
    width: 1200px;
    margin: 0 auto;
  }

  .title {
    font-size: 40px;
    color: #333333;
    font-family: Source Han Sans CN, Source Han Sans CN-6;
    font-weight: 400;
    text-align: center;
  }

  .contactusPc {
    font-size: 12px;
    display: flex;
    flex-direction: column;

    .people{
      padding: 140px 0;
      .peopleCon{
        display: flex;
        margin-top:50px;
        .item{
          width: 25%;
          display: flex;
          flex-direction: column;
          align-items: center;
          .img1{
            width: 56px;
            height: 69px;
            margin-bottom: 12px;
          }
          .img2 {
             width: 64px;
            height: 65px;
            margin-bottom: 16px;
          }
          .img3{
            width:67px;
            height:55px;
            margin-bottom: 26px;
          }
          .img4{
            width:68px;
            height:59px;
            margin-bottom: 22px;
          }
          .txt{
            font-size:26px;
            color: #333333;
            font-weight: 500;
          }
        }
      }
    }

    .team {
      padding: 140px 0;

      .teamCon {
        display: flex;
        margin-top: 59px;

        img {
          width: 500px;
          height: 276px;
        }

        .conTxt {
          font-size: 18px;
          font-family: Source Han Sans CN, Source Han Sans CN-3;
          font-weight: 300;
          margin-left: 33px;
          line-height: 26px;

          h3 {
            margin-top: 0;
            font-size: 24px;
            color: #333333;
            margin-bottom: 23px;
          }

          p {
            margin-bottom: 24px;
          }
        }
      }
    }


    .join {
      padding: 140px 0;

      .joinTitle {
        font-size: 40px;
        color: #333333;
        font-family: Source Han Sans CN, Source Han Sans CN-6;
        font-weight: 500;
        text-align: center;
      }

      .joinUs {
        width: 100%;
        margin-top: 30px;
      }
    }

    .recruitment {
      padding: 140px 0;

      .recruitmentTitle {
        text-align: center;
        color: #333333;
        font-size: 20px;
        font-family: Source Han Sans CN, Source Han Sans CN-6;

        h2 {
          font-size: 40px;
          font-weight: 400;

        }

        p {
          color: #fd8246;
          margin: 30px 0 49px 0;
          font-weight: 500;
        }
      }

      .recruitmentCon {
        .recruitmentItem {
          margin-top: 45px;
          background: #f4f5f8;
          padding: 20px 40px;

          .recruitmentItem_title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 80px;
            overflow: hidden;

            .recruitmentItem_title_h2 {
              font-size: 20px;
              font-weight: 600;
              color: #333333;
              margin: 10px 0 18px;
            }

            .title_desc {
              font-size: 16px;
              font-weight: 300;
              color: #666666;
              line-height: 22px;

              span {
                &:first-child {
                  margin-right: 60px;
                }
              }
            }

            .addShow {
              transform: rotate(180deg);
            }
          }

          .responsibility {
            height: auto;
            overflow: hidden;
            font-size: 16px;
            font-weight: 300;
            color: #666666;
            line-height: 40px;

            >div {
              margin-top: 25px;
              padding-top: 30px;
              border-top: 1px solid #dedfe2;
              h3 {
                font-size:16px;
                color: #666666;
                line-height: 40px;
                margin:0;
                padding:0;
              }
            }
          }

          .draw-enter-active,
          .draw-leave-active {
            transition: all 2s ease;
          }

          .draw-enter,
          .draw-leave-to {
            height: 0;
          }

        }
      }

    }

    @keyframes run {
      from {
        transform: rotate(0deg);
      }

      to {
        transform: rotate(360deg);
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/pc/contactusPc.vue